import React, { useRef, useState } from "react";
import * as PropTypes from "prop-types";
import { databasePropType } from "../../../propTypes";
import { defaultAreaId, reportingYear } from "../../../constants";
import AbsoluteChartToggleFrame from "../../widgets/AbsoluteChartToggleFrame";
import AreaChooser from "../../choosers/AreaChooser";
import ConsumptionCostChart from "./ConsumptionCostChart";

const ConsumptionCostChartWidget = props => {
  const [areaId, setAreaId] = useState(defaultAreaId);

  const ref = useRef();

  return (
    <AbsoluteChartToggleFrame
      dataViewerId="consumption_cost_chart"
      reference="Figure 4.3"
      title={`Consumption Cost by Method, ${reportingYear}`}
      subtitle="Comparison by Sector"
      contentWidth={300}
      filters={[
        <AreaChooser
          id="figure-4-3"
          label="Select Country or Country Group"
          areas={props.database.areas}
          includeCountries={true}
          selectedKey={areaId}
          onChange={areaId => {
            setAreaId(areaId);

            props.onChange({
              widget: "theme4.consumptionCostChart",
              payload: {
                areaId
              }
            });
          }}
        />
      ]}
      initialAbsolute={true}
      chartRef={ref}
      chartSettings={{
        area: props.database.areas[areaId].area
      }}
    >
      <ConsumptionCostChart ref={ref} data={props.data} />
    </AbsoluteChartToggleFrame>
  );
};

ConsumptionCostChartWidget.propTypes = {
  database: databasePropType,
  data: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
};

export default ConsumptionCostChartWidget;
